import Vue from 'vue';
import axios from 'axios';

export default {
  namespaced: true,
  state: {
    selectedOption: undefined,
    selectedFile: {},
    loadingModel: false,
    isModelCorrect: true,
    documentId: null,
    viewsModel: [],
    thumbnailViews: {},
    selectedView: null,
    selectedItem: {},
    selectedCurrentVersion: {},
    currentVersionShared: '',
    loadingVersions: false,
    dialogVersions: false,
    credentialsViewer: {
      token: null,
      timeInSeconds: null,
    },
  },
  getters: {
  },
  mutations: {
    setDialogVersions(state, value) {
      state.dialogVersions = value;
    },
    setCurrentVersionShared(state, currentVersionShared) {
      state.currentVersionShared = currentVersionShared;
    },
    setLoadingVersions(state, loadingVersions) {
      state.loadingVersions = loadingVersions;
    },
    setSelectedItem(state, selectedItem) {
      state.selectedItem = selectedItem;
    },
    setSelectedCurrentVersion(state, selectedCurrentVersion) {
      state.selectedCurrentVersion = selectedCurrentVersion;
    },
    setSelectedOption(state, value) {
      state.selectedOption = value;
    },
    setDocumentId(state, value) {
      state.documentId = value ? `urn:${value}` : value;
    },
    setLoadingModel(state, value) {
      state.loadingModel = value;
    },
    setIsModelCorrect(state, value) {
      state.isModelCorrect = value;
    },
    setCredentialsViewer(state, value) {
      state.credentialsViewer = value;
    },
    setViewsModel(state, value) {
      state.viewsModel = value;
    },
    setThumbnailViews(state, data) {
      Vue.set(state.thumbnailViews, data.key, data.value);
    },
    setSelectedFile(state, data) {
      state.selectedFile = data;
    },
    setSelectedView(state, value) {
      state.selectedView = value;
    },
  },
  actions: {
    async retrieveThumbnail(context, data) {
      const thumbnail = await axios.get(data.url, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      });
      return thumbnail;
    },
  },
};
